import React, { useState, useEffect } from "react";
import "./reports.css";
import { BASE_URL } from "../apiConfig";
import { useParams, useNavigate,useLocation } from "react-router-dom";
import { ChevronLeft, Eye, Search, X } from 'lucide-react';
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import Loading from "./loading"

const Reports = () => {
  const location = useLocation();
  const { inputID } = useParams();
  const mart_id = location.state?.mart_id;
  const projectId = location.state?.project_id || location.state?.projectId;
  const clientID = location.state?.clientID;
  const roleId = location.state?.roleId;
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedMart, setSelectedMart] = useState("Mart_01");
  const [searchQuery, setSearchQuery] = useState("");
  const [resultsPerPage, setResultsPerPage] = useState(
    location.state?.resultsPerPage || 10
  );
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const martsFileName = location.state?.projectName || "Mart_01";

  useEffect(() => {
    fetchReports();
  }, []);

  const fetchReports = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("accessToken");
      if (!token) {
        throw new Error("Unauthorized access. Please log in again.");
      }

      const response = await fetch(
        `${BASE_URL}/reports/get_all_reports_kpi_with_details`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Failed to fetch reports");
      }

      const data = await response.json();
      setReports(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleMartChange = (e) => {
    setSelectedMart(e.target.value);
  };

  const handleResultsPerPageChange = (e) => {
    setResultsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const clearSearch = () => {
    setSearchQuery("");
    setCurrentPage(1);
  };

  const handleViewReport = (reportId, reportCode, title , subtitle,isKpiDependent) => {
    console.log("View report:", reportId);
    console.log("Report code:", reportCode);
    console.log("Report title:", title);
    console.log("Report subtitle:", subtitle);
    navigate(`/architect/${inputID}/${reportId}/${reportCode}/reports_view`, {
      state: {
        title,
        subtitle,
        mart_id,
        isKpiDependent,
        projectId,
        projectName: martsFileName,
        inputID,
        clientID,
        roleId,
        resultsPerPage,
      }, // Pass title via state
    });
  };

  const handleCombineReports = () => {
    console.log("Combine reports");
  };

  const filteredReports = reports.filter((report) =>
    report.title?.toLowerCase().includes(searchQuery.toLowerCase())
  );
  const totalPages = Math.ceil(filteredReports.length / resultsPerPage);
  const startIndex = (currentPage - 1) * resultsPerPage;
  const endIndex = startIndex + resultsPerPage;
  const currentReports = filteredReports.slice(startIndex, endIndex);

  if (loading) {
    // return <div className="loading">Loading reports...</div>;
    <Loading/>
  }

  if (error) {
    return <div className="reports-error">Error: {error}</div>;
  }
  const handleback = () => {
    navigate(`/architect/${inputID}/marts`,{
      state:{
        martsFileName:martsFileName,
        mart_id:mart_id,
        projectId,
        inputID,
        clientID,
        roleId,
      }
    });
  };

  return (
    <div className="reports-container">
      <div className="reports-header">
        <button className="reports-title" onClick={handleback}>
          <span className="back-arrow"><ChevronLeft style={{marginTop: "5px"}}/></span>
          <h1>Reports</h1>
        </button>
        {/* <button className="combine-reports-btn" onClick={handleCombineReports}>
          <span className="combine-icon">⚡</span> Combine Reports
        </button> */}
      </div>

      <div className="reports-toolbar">
        <div className="reports-search-bar">
          <div className="reports-search-input-wrapper">
            <Search className="reports-search-icon" size={16} />
            <input
              type="text"
              className="reports-search-input"
              placeholder="Search reports..."
              value={searchQuery}
              onChange={handleSearchChange}
            />
            {searchQuery && (
              <button className="reports-search-clear-btn" onClick={clearSearch}>
                <X size={14} />
              </button>
            )}
          </div>
        </div>

        <div className="results-per-page">
          <label htmlFor="results-select">Reports per page</label>
          <select
            id="results-select"
            value={resultsPerPage}
            onChange={handleResultsPerPageChange}
            className="results-dropdown"
          >
            <option value={10}>10</option>
            <option value={25}>25</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
          </select>
        </div>
      </div>

      <div className="reports-table-container">
        <table className="reports-table">
          <thead>
            <tr>
              <th>Sl. No.</th>
              <th>Reports Name</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentReports.map((report, index) => (
              <tr key={report.id}>
                <td>{startIndex + index + 1}.</td>
                <td className="report-name">{report.title}</td>
                <td>
                  <button
                    className="view-btn"
                    onClick={() =>
                      handleViewReport(report.id, report.code, report.title, report.sub_title,report.is_kpi_dependent)
                    }
                  >
                    View
                     {/* <span className="view-icon"><RemoveRedEyeOutlinedIcon style={{fontSize: "18px",paddingTop: "3px"}}/></span> */}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {filteredReports.length === 0 && !loading && (
        <div className="no-reports">
          {searchQuery ? `No reports found for "${searchQuery}"` : "No reports available"}
        </div>
      )}
    </div>
  );
};

export default Reports;